var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _mask5, _rect5, _mask6, _rect6, _mask7, _rect7, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 72,
    viewBox: "0 0 90 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3373_1292",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    width: 27,
    height: 13.5,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    width: 27,
    height: 13.5,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_3373_1292)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_3373_1292",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 27,
    width: 18,
    height: 13.5,
    rx: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 27,
    width: 18,
    height: 13.5,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-2-inside-2_3373_1292)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_3373_1292",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 58.5,
    width: 18,
    height: 13.5,
    rx: 0.5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 58.5,
    width: 18,
    height: 13.5,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-3-inside-3_3373_1292)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_3373_1292",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 58.5,
    width: 18,
    height: 13.5,
    rx: 0.5
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 58.5,
    width: 18,
    height: 13.5,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-4-inside-4_3373_1292)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-5_3373_1292",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 58.5,
    width: 18,
    height: 13.5,
    rx: 0.5
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 58.5,
    width: 18,
    height: 13.5,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-5-inside-5_3373_1292)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-6_3373_1292",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 58.5,
    width: 18,
    height: 13.5,
    rx: 0.5
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 58.5,
    width: 18,
    height: 13.5,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-6-inside-6_3373_1292)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-7_3373_1292",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 27,
    width: 18,
    height: 13.5,
    rx: 0.5
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 27,
    width: 18,
    height: 13.5,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-7-inside-7_3373_1292)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 11.25V20.25M45 20.25H66.5C67.0523 20.25 67.5 20.6977 67.5 21.25V29.25M45 20.25H23.5C22.9477 20.25 22.5 20.6977 22.5 21.25V29.25",
    stroke: "#39C5CA",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 38.25V49.5M22.5 49.5H10C9.44772 49.5 9 49.9477 9 50.5V60.75M22.5 49.5H30.5C31.0523 49.5 31.5 49.9477 31.5 50.5V60.75",
    stroke: "#39C5CA",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 38.25V49.5M67.5 49.5H60.5C59.3954 49.5 58.5 50.3954 58.5 51.5V60.75M67.5 49.5H79C80.1046 49.5 81 50.3954 81 51.5V60.75",
    stroke: "#39C5CA",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.8de9d44e344647ad99c48dfe67157d6b.svg";
export { ForwardRef as ReactComponent };